import { RequiredSubInfo, Subscriber } from 'types/electionService';
import { Primitive } from 'types/general';

export interface RequiredIMQInfo {
  categories: IMQCategory[];
  generalInfoFormId: string;
  medicalCoverageFormId: string;
  subFormId: string;
  dependentFormId: string;
}

/**
 * {@link RequiredSubInfo} plus IMQ form metadata. Returned by queries that request the `imq` selection set
 * (see `GET_IMQ_REQUIRED_SUB_INFO` / `getIMQRequiredSubInfo`).
 */
export interface RequiredSubInfoWithIMQ extends RequiredSubInfo {
  imq: RequiredIMQInfo;
}

export interface IMQCategory {
  name: string;
  formId: string;
}

export interface ConditionMember {
  id: string;
  answers: Record<string, Primitive>;
}

export interface MedicalCondition {
  name: string;
  members: ConditionMember[];
}

export interface IMQCategoryAnswers {
  name: string;
  answers: Record<string, Primitive>;
  medicalConditions: MedicalCondition[];
}

export interface IMQAnswers {
  categories: IMQCategoryAnswers[];
}

export enum MedicalConditionStatus {
  DETAILS_MISSING = 'DETAILS_MISSING',
  COMPLETED = 'COMPLETED',
}

export enum CategoryStatus {
  COMPLETED = 'COMPLETED',
  DETAILS_MISSING = 'DETAILS_MISSING',
  NOT_STARTED = 'NOT_STARTED',
}

export interface FamilyMember {
  id: string;
  name: string;
  answers: Record<string, Primitive>;
}

export interface MedicalConditionPresenter {
  name: string;
  affectedPeople: FamilyMember[];
  status: MedicalConditionStatus;
}

export interface FamilyCensus {
  [key: string]: {
    type: 'PRIMARY' | 'SPOUSE' | 'DEPENDENT';
    name: string;
  };
}

export interface SubscriberIMQ extends Subscriber {
  imqAnswers?: IMQAnswers;
}
